<cam-layout-page>
  <cam-layout-header>
    <cam-layout-header-default></cam-layout-header-default>
  </cam-layout-header>

  <cam-layout-title> Styles </cam-layout-title>

  <cam-layout-content> Content </cam-layout-content>

  <cam-layout-nav>
    <app-menu-main></app-menu-main>
  </cam-layout-nav>
</cam-layout-page>
